<template>
  <div class="performance-index container">
    <h1 class="nav-title">{{ $t("performance.title") }}</h1>
    <div class="layout align-center">
      <v-btn text :color="mode == 1 ? 'primary' : ''" @click="mode = 1"> <v-icon left>mdi-list-box-outline</v-icon>列表模式 </v-btn>
      <v-btn text :color="mode == 2 ? 'primary' : ''" @click="mode = 2"> <v-icon left>mdi-calendar-month-outline</v-icon>日历模式 </v-btn>
      <v-spacer />
      <div>
        <v-select :items="months" return-object v-model="month" class="d-none d-md-flex" :placeholder="$t('performance.month-select')" />
      </div>
    </div>
    <cpo-performance-list :items="items" :mode="mode" />
  </div>
</template>

<script>
import CpoPerformanceList from "@/components/CpoPerformanceList.vue";

export default {
  components: {
    CpoPerformanceList
  },
  data() {
    return {
      items: [],
      settings: {
        page: 1,
        pageSize: 12
      },
      months: [],
      month: null,
      locale: {
        "en-gb": "MMMM YYYY",
        "zh-cn": "YYYY年M月"
      },
      mode: 1
    };
  },
  created() {
    this.load();
    this.generateMonths();
  },
  methods: {
    reset() {
      this.settings.page = 1;
      this.pageSize = 12;
      this.items = [];
      this.load();
    },
    load() {
      var filter = [];

      if (this.month) {
        filter.push({
          operator: "Gte",
          field: "date",
          value: this.month.start
        });
        filter.push({ operator: "Lte", field: "date", value: this.month.end });
      }
      this.$axios
        .post("/performance/list", {
          ...this.settings,
          filter,
          sort: [{ field: "date", asc: false }]
        })
        .then((data) => {
          this.items = data;
        });
    },
    generateMonths() {
      var start = this.$moment().startOf("M").subtract(9, "M");
      this.months = Array.from(Array(12).keys()).map((i) => {
        var t = start.clone().add(i, "M");
        return {
          text: t.format(this.locale[this.$i18n.locale]),
          value: i,
          start: t.startOf("M").format(),
          end: t.endOf("M").format()
        };
      });
    },
    gotoView(id) {
      this.$router.push({ name: "performance-view", params: { id } });
    }
  },
  watch: {
    "$i18n.locale": {
      handler: "generateMonths",
      immediate: true
    },
    month: "reset"
  }
};
</script>

<style lang="scss"></style>
